export enum MeaCarouselTemplateConst {
  DEFAULT = 'defualt',
  DETOUR = 'detour',
}
